import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BillfoldInvoiceList from './components/BillfoldInvoiceList';

const BillfoldPortfolio = () => {
  return (
    <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 style={{ marginBottom: 15 }}>Cartera</h3>
                </Col>
            </Row>
            <Row>
                <BillfoldInvoiceList />
            </Row>
        </Container>
  )
}

export default BillfoldPortfolio